import r from "./index269.js";
import { createElementBlock as o, openBlock as a, createStaticVNode as n, createElementVNode as s, renderSlot as i } from "vue";
import f from "./index231.js";
const d = ["data-component"], c = { class: "text-center text-text-l" };
function m(t, e, l, p, u, h) {
  return a(), o("div", {
    class: "relative flex flex-col items-center",
    "data-component": t.$options.name
  }, [
    e[0] || (e[0] = n('<svg height="72" width="72" viewBox="0 0 72 72" class="mb-4"><circle cx="36" cy="36" r="32" fill="transparent" stroke-width="8px" stroke="#f7f6ef"></circle><path d="M 4 36 a 32 32 0 0 0 64 0 a 32 32 0 0 0 -64 0" fill="transparent" stroke-width="8px" stroke="#ffe857" stroke-linecap="round" stroke-dasharray="201" stroke-dashoffset="0" transform-origin="center"><animate attributeName="stroke-dashoffset" values="200; 100; 20; 100; 200;" dur="3s" repeatCount="indefinite"></animate><animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="1s" repeatCount="indefinite"></animateTransform></path></svg>', 1)),
    s("div", c, [
      i(t.$slots, "default")
    ])
  ], 8, d);
}
const v = /* @__PURE__ */ f(r, [["render", m]]);
export {
  v as default
};
